const commonAllergies = [
    "Seasonal (Allergic Rhinitis)",
    "Food",
    "Insect Sting",
    "Medication",
    "Latex",
    "Allergic Contact Dermatitis",
    "Pet",
    "Mold",
    "Dust Mite",
    "Pollen (Hay Fever)",
    "Peanut",
    "Tree Nut",
    "Milk",
    "Egg",
    "Soy",
    "Wheat",
    "Fish",
    "Shellfish",
    "Bee Sting",
    "Wasp Sting",
    "Poison Ivy",
    "Poison Oak",
    "Cat",
    "Dog",
    "Penicillin",
    "Aspirin",
    "Ibuprofen",
    "Paracetamol",
    "Codeine",
    "Amoxicillin",
    "Ciprofloxacin",
    "Clarithromycin",
    "Doxycycline",
    "Naproxen",
    "Sulfa Drugs",
    "Cephalosporins",
  ];
 
  export default commonAllergies